import styled, { css } from 'styled-components/macro'
import StockCounter from '../../../../components/shared/Store/StockCounter/StockCounter'
import ImageCounter from '../../../../components/shared/Store/ImageCounter/ImageCounter'
import ShippableIcon from '../../../../components/shared/Store/ShippableIcon/ShippableIcon'
import AddButton from '../../../../components/shared/Store/AddButton/AddButton'
import RemoveButton from '../../../../components/shared/Store/RemoveButton/RemoveButton'
import ProductName from '../../../../components/shared/Store/ProductName/ProductName'
import ProductPrice from '../../../../components/shared/Store/ProductPrice/ProductPrice'
import { prop, theme, ifProp } from 'styled-tools'
import { CardFooter as CardFooterBootstrap } from 'reactstrap'
import { media, matchMedia } from 'ui/rwd'
import posed from 'react-pose'

const boxShadow = css`
  box-shadow: 2px 2px 9px 0px rgba(0, 0, 0, 0.3);
`

const CardStockCounter = styled(StockCounter)`
  position: absolute;
  top: 0.7rem;
  left: 0;
  ${boxShadow}
`
const CardImageCounter = styled(ImageCounter)`
  position: absolute;
  top: 0.7rem;
  right: 0.7rem;
  cursor: pointer;
  ${boxShadow}
`

const CardImageContainer = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
`

const CardImage = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url('${prop('src', '')}');
  width: 100.5%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`

const CardFooter = styled(CardFooterBootstrap)`
  position: relative;
  padding: 0.5rem 1rem;
  background: ${theme('productBoxBackground')};
  border-top: none !important;
`

const CardFooterContainer = styled.div`
  flex-direction: row;
  display: flex;
`

const CardShippableIcon = styled(ShippableIcon)`
  padding-right: 3px;
  padding-left: 3px;
`

const CardAddButton = styled(AddButton).attrs({
  size: '3.6rem'
})`
  position: absolute;
  bottom: -55px;
  ${media.sm`
    bottom: -65px;
  `}
  div {
    ${boxShadow}
  }
`

const CardRemoveButton = styled(RemoveButton).attrs({
  size: '3.6rem'
})`
  position: absolute;
  bottom: 6px;
  div {
    ${boxShadow}
  }
  ${media.md`
    bottom:8px;
  `}
  ${media.lg`
    bottom:18px;
  `}
`

const CardProductName = styled(ProductName)`
  max-width: 70%;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 3.4rem;
  ${media.xl`
    max-width: 80%;
  `}
`

const CardProductPrice = styled(ProductPrice)`
  margin-right: 5px;
  z-index: 20;
  margin-bottom: 0;
  border: ${ifProp('isWholesale', '2px solid green', 'auto')};
`

const CardButtonContainer = styled.div`
  position: absolute;
  right: 55px;
  bottom: 112px;
  ${media.lg`
    right: 68px;
    bottom: 83px;
  `}
`

const AnimatedProductCount = posed.span({
  enter: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 0.2
  }
})
const AnimatedCard = posed.div({
  visible: {
    opacity: 1,
    y: 0,
    transition: ({ i }) => ({
      type: 'spring',
      stiffness: 150,
      damping: 15,
      delay: (i % 2) * 100 + 100,
      ...matchMedia.sm({
        delay: (i > 2 ? (i % 3) * 100 : i * 100) + 100
      }),
      ...matchMedia.md({
        delay: (i > 3 ? (i % 4) * 100 : i * 100) + 100
      })
    })
  },

  hidden: {
    opacity: 0,
    y: 100
  }
})

const Card = styled(AnimatedCard)`
  &.card {
    border: 0;
    box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.15);
    &:hover {
      box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.22);
    }
  }
`

const Container = styled.div``

export {
  CardStockCounter,
  CardImageCounter,
  CardImageContainer,
  CardImage,
  CardFooter,
  CardFooterContainer,
  CardShippableIcon,
  CardAddButton,
  CardRemoveButton,
  CardProductName,
  CardProductPrice,
  CardButtonContainer,
  AnimatedProductCount,
  Card,
  Container
}
